var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "timeline" },
    [
      _vm._v(" " + _vm._s(_vm.longDate) + " | " + _vm._s(_vm.price)),
      _vm.ageRestriction
        ? [_vm._v(" | " + _vm._s(_vm.ageRestriction))]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }